import clsx from 'clsx';
import { useCallback, useContext } from 'react';

import { CloseButton, CloseButtonSize, GlobalsContext } from '@vestico/shared';

import { getIsRTL } from '@vestico/i18n';

import style from './ContentHeaderBar.module.css';

export interface ContentHeaderBarProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const ContentHeaderBar = ({ open, setOpen }: ContentHeaderBarProps) => {
  const { useMobileLayout } = useContext(GlobalsContext);
  const onToggle = useCallback(() => setOpen(!open), [open, setOpen]);

  return (
    <div className={clsx(style.root, { [style.rtl]: getIsRTL() })}>
      <CloseButton title={open ? 'Close' : 'Open'} size={useMobileLayout ? CloseButtonSize.medium : CloseButtonSize.small} onClick={onToggle} />
    </div>
  );
};
